/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Triggers_Kind_Picker_TitleInputs */



/**
* | output |
* | --- |
* | "What should start this agent?" |
*
* @param {Agent_Triggers_Kind_Picker_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_triggers_kind_picker_title = /** @type {((inputs?: Agent_Triggers_Kind_Picker_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Triggers_Kind_Picker_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Was soll diesen Agenten starten?")
	return /** @type {LocalizedString} */ ("What should start this agent?")
});